import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("mandantentable");

 const resetData = actionCreator<{data:userdata[]}>("MANDANTENTABLE_RESETDATA");

 export const TableThingyActions = { resetData}


